<template>
  <v-dialog v-model="dialog" width="1000px" >
    <v-card class="pa-4" v-if="!loading">
      <p class="title">Cancel booking {{huov.huov_code}}
        <span v-if="huov.verkoopuitleg.hasCancellationInsurance" class="insurance-warning">Guest has cancellation insurance</span>
      </p>
      <v-card-text style="font-size: 1rem; max-height: 70vh; overflow-y: auto; color: #000000;">
<!-- verkoop gast -->
        <v-row no-gutters class="sub-title align-center">
          <span>Guest: {{ huov.verkoopuitleg.guest }}</span>
          <span style="font-weight: normal; padding-left: 20px; font-style: italic;">
            ({{ huov.verkoopuitleg.klav_nr }})  {{ huov.verkoopuitleg.klav_oms }}
          </span>
        </v-row>
        <v-row no-gutters class="mt-3">
          <ul>
            <div v-for="(term, idx) in huov.verkoopuitleg.terms" :key="'verkoop-' + idx">
              <li>
                <div :class="{'selected': huov.verkoopuitleg.kavr_nr === term.kavr_nr}"> {{ term.kavr_oms }} </div>
              </li>
            </div>
          </ul>
        </v-row>
        <v-row no-gutters cols="12" class="mt-2">
          <v-col cols="5"> {{ huov.verkoopuitleg.advb_text }} </v-col>
          <v-col cols="1" class="num-days">{{ huov.verkoopuitleg.advb }} {{ huov.verkoopuitleg.advb_days }}</v-col>
        </v-row>
        <v-row no-gutters cols="12">
          <v-col cols="5"> {{ huov.verkoopuitleg.percentage_text }} {{ huov.verkoopuitleg.percentage }}%</v-col>
        </v-row>
        <v-row no-gutters cols="12" v-for="(vamount, idx) in huov.verkoopuitleg.amounts" :key="idx">
          <v-col cols="5"> {{ vamount.text }} </v-col>
          <v-col cols="1" class="num-days">{{ vamount.hklr_bedrag.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</v-col>
        </v-row>
        <v-row no-gutters cols="12" class="my-1">
          <v-col cols="1" offset="5" class="num-days"><hr style="width: 100%"></v-col>
        </v-row>
        <v-row no-gutters cols="12">
          <v-col cols="5"> {{ huov.verkoopuitleg.totalcosts_text }} </v-col>
          <v-col cols="1" class="num-days">{{ huov.verkoopuitleg.totalcosts.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</v-col>
        </v-row>
<!-- inkoop host -->
        <hr class="mt-3 mb-4"/>
        <v-row no-gutters class="sub-title mt-2">
            <span>Host: {{ huov.inkoopuitleg.host }}</span>
            <span style="font-weight: normal; padding-left: 20px; font-style: italic;">
              ({{ huov.inkoopuitleg.hsav_nr }})  {{ huov.inkoopuitleg.hsav_oms }}
            </span>
        </v-row>
        <!-- <v-row no-gutters class="sub-title mt-2">Host: {{ huov.inkoopuitleg.host }}</v-row>  -->
        <v-row no-gutters class="mt-3">
          <ul>
            <div v-for="(term, idx) in huov.inkoopuitleg.terms" :key="idx">
              <li class="">
                <div :class="{'selected': huov.inkoopuitleg.havr_nr === term.havr_nr}"> {{ term.havr_oms }} </div>
              </li>
            </div>
          </ul>
        </v-row>
        <v-row no-gutters cols="12" class="mt-2">
          <v-col cols="5"> {{ huov.inkoopuitleg.adnb_text }} </v-col>
          <v-col cols="1" class="num-days">{{ huov.inkoopuitleg.adnb }} {{ huov.inkoopuitleg.advb_days }}</v-col>
        </v-row>
        <v-row no-gutters cols="12">
          <v-col cols="5"> {{ huov.inkoopuitleg.advb_text }} </v-col>
          <v-col cols="1" class="num-days">{{ huov.inkoopuitleg.advb }} {{ huov.inkoopuitleg.advb_days }}</v-col>
        </v-row>
        <v-row no-gutters cols="12">
          <v-col cols="5"> {{ huov.inkoopuitleg.percentage_text }} {{ huov.inkoopuitleg.percentage }}%</v-col>
        </v-row>
        <v-row no-gutters cols="12" v-for="(amount, idx) in huov.inkoopuitleg.amounts" :key="'inkoop-' + idx">
          <v-col cols="5"> {{ amount.text }} </v-col>
          <v-col cols="1" class="num-days">{{ amount.hctr_bedrag.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</v-col>
        </v-row>
        <v-row no-gutters cols="12" class="my-1">
          <v-col cols="1" offset="5" class="num-days"><hr style="width: 100%"></v-col>
        </v-row>
        <v-row no-gutters cols="12" class="mb-2">
          <v-col cols="5"> {{ huov.inkoopuitleg.totalcosts_text }} </v-col>
          <v-col cols="1" class="num-days">{{ huov.inkoopuitleg.totalcosts.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</v-col>
        </v-row>
<!-- einde -->
      </v-card-text>
      <v-card-actions>
        <v-select v-model="initiated" :items="huov.initiatedKeuzes" item-value="id"  item-text="desc" label="Initiated" clearable style="width: 300px"></v-select>
        <v-spacer></v-spacer>
        <v-btn class="primary mr-2" small @click="huovCancel" :disabled="initiated===''||initiated===null">Cancel the booking</v-btn>
        <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      huovCancelValid: false,
      huov_encrid: null,
      huov_bedrag: null,
      initiatedKeuzes: [],
      initiated: null,
      huov: {},
      loading : true,
      initiatedRules: [
          v => (v && v.length >= 3) || "Who has initiated the cancellation"
      ],
    }
  },
  methods: {
    open(huov_encrid) {
      // var deze = this;
      this.$emit("showSnackbar");
      this.huov_encrid = huov_encrid;
      this.loading = true
      this.$axios
        .post("ares/json/ares/huov/getHuovToCancel2.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuovToCancel"
          },
          getHuovToCancel: {
            huov_encrid: huov_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huov = res.data.getHuovToCancel
            //console.log(this.huov)
            this.initiatedKeuzes = res.data.getHuovToCancel.initiatedKeuzes
            this.loading = false
            this.dialog = true;
          }
        })
    },
    huovCancel() {
      this.$axios
        .post("ares/json/ares/huov/huovCancel2.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "huovCancel"
          },
          huovCancel: {
            huov_encrid: this.huov_encrid,
            initiated: this.initiated
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
             this.$router.reload('/huov/onHuov/' + res.data.huovCancel.huov_encrid);
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.huovCancel.text,
              color: res.data.huovCancel.color
            });
            this.dialog = false;
          }
        })
    },
  }
}
</script>

<style scoped>
ul {
  list-style: disc;
}
.selected {
  font-weight: bold;
  color: green;
}
.num-days {
  display:flex;
  flex-direction: row;
  justify-content: flex-end;
}
.sub-title{
  font-size: 1.0em;
  font-weight: bold;
}
.title{
  font-size: 1.2em;
  font-weight: bold;
}
.insurance-warning {
  font-weight: 500;
  border: solid 2px orange;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 16px;
  padding-right: 16px;
  border-radius: 5px;
  margin-left: 20px;
  color: #666;
}
</style>